
























































































































































import Vue from 'vue'
import { Component } from 'vue-property-decorator'
import Subscription, {StripeInvoice, StripeUpcomingInvoice} from '../../../../../api/v2/models/subscription'
import { subscriptionState } from '../../../../stores/subscription'
import PremiumService, {SubscriptionCompare} from '../../../../../api/v2/models/pre_service'
import { format } from 'date-fns'
import { calcTaxIncluded } from '../../../../utils/price'



@Component({
  components: {
  },
})
export default class ChangePlanPlanConfirm extends Vue {
  subscription: Subscription | null = new Subscription({})
  stripeUpcomingInvoice: StripeUpcomingInvoice | null = null
  stripeLastInvoice: StripeInvoice | null = null
  targetPremiumService: PremiumService | null = null
  subscriptionCompared: SubscriptionCompare | null = null
  isLoading = true
  calcTaxIncluded = calcTaxIncluded
  // localNumber = localNumber

  created() {
    this.getSubscription()
    this.getTargetPremiumService()
  }

  getSubscription() {
    subscriptionState.getSubscription(this.$route.params.subscriptionId as any).then((response) => {
      if (response) {
        this.subscription = response.subscription
        if (this.subscription.isStoped) {
          window.location.href = '/classroom/subscription/' + this.subscription.id
        }
        this.stripeUpcomingInvoice = response.stripeUpcomingInvoice
        this.stripeLastInvoice = response.stripeInvoices[0]
      }
    })
  }

  getTargetPremiumService() {
    subscriptionState.getTargetPremiumService(this.$route.params.subscriptionId as any, this.$route.query.targetPremiumServiceId as any).then((response) => {
      if (response) {
        this.targetPremiumService = response
        this.subscriptionCompared = response.subscriptionCompare
        this.isLoading = false
      }
    })
  }

  submitChangePlan() {
    this.$router.push(`/classroom/subscription/${this.$route.params.subscriptionId}/change-plan/payment-confirm?targetPremiumServiceId=${this.targetPremiumService?.id}`)
  }

  dateFormat(date: Date) {
    return format(date, 'YYYY/MM/DD')
  }

  localNumber(number: number) {
    return new Intl.NumberFormat("ja-JP").format(number)
  }
  

}
